import aframe from "aframe";

// const flashTime = 100;

aframe.registerSystem("crosshair", {
  init() {
    this.poolEl = document.querySelector("[mipool__crosshair]");
  },
  spawn(missile, position) {
    const instance = this.poolEl.components.mipool__crosshair.requestEntity();
    if (instance !== undefined) {
      instance.components.crosshair.reset();
      instance.object3D.position.copy(position);
      instance.components.crosshair.setMissile(missile);
      instance.play();
      return instance;
    }
  },
  release(crosshair) {
    this.poolEl.components.mipool__crosshair.returnEntity(crosshair);
  }
});

aframe.registerComponent("crosshair", {
  init() {
    this.reset();
  },
  reset() {
    this.timer = 0;
    this.missile = undefined;
  },
  tick(t, dt) {
    this.timer += dt;
    if (this.missile === undefined) {
      // If there is no missile we cannot proceed beyond this point
      if (this.timer > 500)
        this.system.release(this.el);
      return;
    }
    const distanceToMissile = this.el.object3D.position.distanceTo(
      this.missile.object3D.position);
    if (distanceToMissile <= 0.01 || this.missile.getAttribute("visible") === false)
      this.system.release(this.el);
  },
  setMissile(missile) {
    this.missile = missile;
  }
});
